module.exports = __webpack_public_path__ + "static/Tile4-Normal-footage-f7ad3a252af0c0228dc41400ece37f6a.gif";